<div class="dwm-app-wrapper d-flex full-height">
  <app-navigation></app-navigation>

  <div class="app-content-wrapper">
    <app-header></app-header>
    <router-outlet></router-outlet>
  </div>
</div>